export function targetForMonth(rows,month){
 const specific=rows.find(r=>r.kind==='month'&&r.month.slice(0,7)===month);
 const fallback=rows.filter(r=>r.kind==='default'&&r.month.slice(0,7)<=month).sort((a,b)=>b.month.localeCompare(a.month))[0];
 const row=specific||fallback;return row?Number(row.amount):null;
}
export function targetProgress(actual,target){return target>0?{percent:actual/target*100,remaining:Math.max(0,target-actual)}:null;}
